import { ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WorkflowDeploymentStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum WorkflowDeploymentConfigurationLabel {
  Treatment = 'treatment',
  Control = 'control',
}

interface WorkflowDeploymentConfigurationVersion {
  token: string;
  percentage: number;
  label?: string;
}

export interface WorkflowDeploymentConfiguration {
  versions: WorkflowDeploymentConfigurationVersion[];
}

export interface WorkflowDeploymentAttributes {
  status: WorkflowDeploymentStatus;
  'created-at': string;
  configuration: WorkflowDeploymentConfiguration;
}

export interface WorkflowDeploymentRelationships {
  workflow: ApiRelationship;
}

export type WorkflowDeployment = ApiResource<
  WorkflowDeploymentAttributes,
  WorkflowDeploymentRelationships
>;
